import { useParams, useHistory, useLocation } from 'react-router-dom';

import Routes from 'config/routes';

import useSaveFrom from 'hooks/useSaveFrom';
import useAuthentication from 'domain/authentication/useAuthentication';
import useReadRecipe from 'domain/recipe/useReadRecipe';

const useRecipesPage = () => {
  const { id } = useParams();
  const history = useHistory();
  const { user, isAuthenticated } = useAuthentication();
  const location = useLocation();
  const from = useSaveFrom('recipes_from');
  const {
    recipe,
    recipeLiked,
    recipeBookmarked,
    hasFailed,
    hasLoaded,
    isLoading,
    loadRecipe,
    notFound,
  } = useReadRecipe(id, 25);

  const exitPage = () => history.replace(from);

  const goToEditPage = () => {
    history.push({
      pathname: Routes.editRecipe(id)(),
      state: { from: location },
    });
  };

  return {
    recipe,
    recipeLiked,
    recipeBookmarked,
    isLoading,
    hasFailed,
    hasLoaded,
    notFound,
    isRecipeOwnedByUser:
      hasLoaded && isAuthenticated && recipe.userID === user.id,
    loadRecipe,
    exitPage,
    goToEditPage,
    isAuthenticated,
  };
};

export default useRecipesPage;
